import { type Goal, GoalCategory } from "web_myplann/Goals/Types/GoalTypes";

export const DUMMY_ACTIVE_GOALS: Goal[] = [
	{
		id: "goal-1",
		name: "Vlastní bydlení",
		category: GoalCategory.Housing,
		status: "on-track",
		totalValue: 3000000,
		dueIn: "3 roky",
		contracts: [
			{ id: "c1", name: "Stavební spoření", value: 850000 },
			{ id: "c2", name: "Investiční fond", value: 420000 },
		],
	},
	{
		id: "goal-2",
		name: "Finanční rezerva",
		category: GoalCategory.Custom,
		status: "warning",
		totalValue: 500000,
		dueIn: "1 rok",
		contracts: [{ id: "c3", name: "Spořicí účet", value: 180000 }],
	},
	{
		id: "goal-3",
		name: "Důchod",
		category: GoalCategory.Retirement,
		status: "off-track",
		totalValue: 8000000,
		dueIn: "25 let",
		contracts: [
			{ id: "c4", name: "Penzijní připojištění", value: 320000 },
			{ id: "c5", name: "DIP", value: 150000 },
		],
	},
];

export const DUMMY_COMPLETED_GOALS: Goal[] = [
	{
		id: "goal-4",
		name: "Dovolená v Řecku",
		category: GoalCategory.Vacation,
		status: "on-track",
		totalValue: 80000,
		dueIn: "Splněno",
		contracts: [{ id: "c6", name: "Spořicí účet", value: 80000 }],
		completed: true,
	},
	{
		id: "goal-5",
		name: "Nové auto",
		category: GoalCategory.Car,
		status: "on-track",
		totalValue: 450000,
		dueIn: "Splněno",
		contracts: [{ id: "c7", name: "Úvěr", value: 450000 }],
		completed: true,
	},
];

export const EXAMPLE_GOAL_CATEGORIES = [
	GoalCategory.Retirement,
	GoalCategory.Housing,
	GoalCategory.Vacation,
] as const;

export type ExampleGoalCategory = (typeof EXAMPLE_GOAL_CATEGORIES)[number];
